import React from 'react'
import useTrans from '@hooks/useTrans'
import useTransRoute from '@hooks/useTransRoute'
// import { trackingGAevent } from '@utils/gtm'
import { checkValidCoords } from '@utils/rivenditori'
import { Button } from '@components/atoms'
import styles from './RivenditoreCardContent.module.sass'

interface HeadProps {
  rivenditore: any
  titleId?: string
  className?: string
}

interface BodyProps {
  rivenditore: any
  showCta?: boolean
  // onShowMapClick?: () => void
  className?: string
}

interface Props {
  rivenditore?: any
  size?: 'sm' | 'md'
  variant?: '' | 'accordion'
  className?: string
}

export const RivenditoreCardHead = (props: HeadProps) => {
  const { rivenditore = undefined, titleId = undefined, className = '' } = props

  return rivenditore ? (
    <>
      {!!rivenditore.nome && (
        <h2 className={`${styles.title} ${className}`} id={titleId}>
          {rivenditore.nome}
        </h2>
      )}
    </>
  ) : (
    <></>
  )
}

export const RivenditoreCardBody = (props: BodyProps) => {
  const {
    rivenditore = undefined,
    showCta = true,
    // onShowMapClick = undefined
    className = '',
  } = props

  const t = useTrans()
  const tr = useTransRoute()

  return rivenditore ? (
    <div className={`${styles.body} ${className}`}>
      {(!!rivenditore.indirizzo ||
        !!rivenditore.cap ||
        !!rivenditore.citta ||
        !!rivenditore.provincia?.nome) && (
        <div className={styles.address}>
          {!!rivenditore.indirizzo && <p>{rivenditore.indirizzo}</p>}
          {(!!rivenditore.cap || !!rivenditore.citta || !!rivenditore.provincia?.nome) && (
            <p>
              {[rivenditore.cap, rivenditore.citta, rivenditore.provincia]
                .filter((x) => x)
                .join(' ')}
            </p>
          )}
        </div>
      )}
      <div className={styles.ctaBox}>
        <Button
          label={t('Contatta')}
          href={tr('/rivenditori/contatta/[slug]')?.href?.replace('[slug]', rivenditore.pk)}
          className={styles.cta}
          // onClick={() => {
          //   trackingGAevent('appuntamento_filiale', {
          //     branch_category: rivenditore.tipologia?.nome?.toLowerCase() || '',
          //     branch_code: rivenditore.codice && rivenditore.codice !== ' - ' ? rivenditore.codice : '',
          //   })
          // }}
        />
        {checkValidCoords(rivenditore.latitudine, rivenditore.longitudine) && (
          <div className={styles.ctaMapBox}>
            <Button
              label={t('Indicazioni sulla mappa')}
              size="lg"
              variant="ghost"
              className={styles.ctaMap}
              newPage
              href={`https://www.google.com/maps/dir/Current+Location/${rivenditore.latitudine},${rivenditore.longitudine}/`}
            />
          </div>
        )}
      </div>
    </div>
  ) : (
    <></>
  )
}

const RivenditoreCardContent = (props: Props) => {
  const { rivenditore = undefined, size = 'md', variant = '', className = '' } = props

  return rivenditore ? (
    <div className={`${styles.root} ${size ? styles[`root--${size}`] : ''} ${className}`}>
      <RivenditoreCardHead rivenditore={rivenditore} />
      <RivenditoreCardBody rivenditore={rivenditore} />
    </div>
  ) : (
    <></>
  )
}

export default RivenditoreCardContent
